import { useSegments } from 'expo-router';

import useScrollListenerScene from '@/hooks/useScrollListenerScene';

/** Get the scroll props for a child route of a collapsible tabs layout route. */
export function useScrollListener() {
  const segments = useSegments();
  const activeRouteKey = segments[segments.length - 1];

  return useScrollListenerScene(activeRouteKey);
}
